import React, { useState } from "react";
import { Link } from "react-router-dom";
import MainContent from "@components/content";
import Timeline from "@components/timeline";
import css from "../index.module.css";

const timelineData = [
  {
    status: "Отдел МВД",
    date: "Август 2025",
    title: "Обнаружение незаконного запрета",
    color: "danger",
    description:
      "В общедоступном фойе дежурной части МВД обнаружена табличка, запрещающая видеосъемку под неправомерной угрозой привлечения по статье 19.3 КоАП РФ.",
  },
  {
    status: "Надзорные органы",
    date: "Август 2025",
    title: "Подача жалобы в прокуратуру",
    color: "warning",
    description:
      "Направлено официальное обращение в прокуратуру с правовым обоснованием того, что фойе является общественным местом, где съемка разрешена.",
  },
  {
    status: "Прокуратура / МВД",
    date: "Сентябрь 2025",
    title: "Проведение проверки",
    color: "default",
    description:
      "Рассмотрение жалобы надзорным органом и проверка законности действий руководства отдела полиции по ограничению прав.",
  },
  {
    status: "Отдел МВД",
    date: "Октябрь 2025",
    title: "Устранение нарушения",
    color: "success",
    description:
      "Незаконная табличка демонтирована из общедоступного фойе и перевешена во внутренние служебные помещения.",
  },
];

const initialCaseStatus = {
  label: "Удовлетворено",
  code: "satisfied",
  variant: "satisfied",
};

const LegalCase2Page = () => {
  const [caseStatus] = useState(initialCaseStatus);

  return (
    <MainContent>
      <div className={css.casePage}>
        <div className={css.caseHeader}>
          <div className={css.caseHeaderTop}>
            <Link to="/legal" className={css.backLink}>
              <span className={css.backIcon}>←</span>
              <span>Назад к делам</span>
            </Link>
            <div
              className={`${css.caseStatus} ${
                css[`caseStatus_${caseStatus.variant}`]
              }`}
            >
              <span className={css.caseStatusDot} />
              <span className={css.caseStatusText}>{caseStatus.label}</span>
            </div>
          </div>
          <h1>Обжалование незаконного запрета на видеосъемку в МВД</h1>
          <span className={css.caseMeta}>
            Федеральное законодательство · 2025 г.
          </span>
        </div>

        <div className={css.caseLayout}>
          <div className={css.caseDescription}>
            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Суть (фабула)</div>
              <p>
                В общедоступном помещении (фойе дежурной части) отдела МВД была размещена информационная табличка, категорически запрещающая фото- и видеосъемку. За нарушение данного запрета табличка содержала прямую угрозу привлечения граждан к административной ответственности по ст. 19.3 КоАП РФ (неповиновение законному распоряжению сотрудника полиции).
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Моя позиция</div>
              <p>
                Данный запрет является незаконным. Фойе дежурной части отдела полиции является общественным местом. Согласно ст. 29 Конституции РФ и ч. 1 ст. 8 ФЗ «О полиции», деятельность полиции является открытой, а граждане имеют право свободно искать и получать информацию любым законным способом. 
              </p>
              <p style={{ marginTop: 10 }}>
                Угроза применения ст. 19.3 КоАП РФ за съемку в общедоступном месте неправомерна, так как требование сотрудника прекратить видеофиксацию в таком случае не отвечает критерию «законности распоряжения».
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Позиция ведомства</div>
              <p>
                Изначально должностные лица ссылались на внутренние приказы о пропускном режиме, а также на требования антитеррористической защищенности зданий органов внутренних дел, пытаясь распространить режим секретности на общедоступное фойе.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Итог (резюме)</div>
              <p>
                После направления жалобы в прокуратуру с просьбой провести проверку законности действий руководства отдела, незаконная табличка была демонтирована. Запрещающий знак перенесли за пределы фойе дежурной части — во внутренние служебные помещения, действительно закрытые для свободного посещения гражданами.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle}>Правовые последствия</div>
              <p>
                На практике пресечена попытка незаконного ограничения прав граждан (в том числе журналистов) на сбор информации и видеофиксацию в общедоступных помещениях государственных органов.
              </p>
              <p style={{ marginTop: 10 }}>
                Дело подтверждает, что ведомственные приказы (ДСП) и внутренние инструкции по режиму объектов не могут подменять собой федеральное законодательство и ограничивать конституционные права граждан в тех зонах, куда открыт свободный доступ.
              </p>
            </div>

            <div className={css.caseSection}>
              <div className={css.caseSectionTitle} style={{ margin: 0 }}>Материалы</div>
              <div className={css.caseMaterialsList}>
                <a href="https://dash.leecyber.com/drive/shared/7fb9f519-0209-40d4-b1db-6114360806ab" className={css.caseMaterialLink} target="_blank" rel="noreferrer">
                  Ответ надзорного органа
                </a>
              </div>
            </div>
          </div>

          <div className={css.caseTimeline}>
            <div className={css.caseSectionTitle} style={{ marginBottom: 25 }}>Ход дела</div>
            <Timeline data={timelineData} />
          </div>
        </div>
      </div>

      <p className={css.caseDisclaimer}>
        Все представленные дела — результат моей самостоятельной практики. Опубликованные материалы не являются профессиональной юридической консультацией, носят исключительно ознакомительный характер и отражают мое субъективное мнение.
      </p>
    </MainContent>
  );
};

export default LegalCase2Page;